<template>
  <div class="app">
    <div class="main">
      <div class="title" :class="active == 1 ? 'blackTheme' : ''"></div>
      <router-link to="/" class="tab">
        <div :style="active == 1 ? 'color:#fff' : ''">首页</div>
      </router-link>
      <router-link to="/science" class="tab">
        <div :style="active == 1 ? 'color:#fff' : ''">品牌与科学</div>
      </router-link>
      <router-link to="/home" class="tab">
        <div :style="active == 1 ? 'color:#fff' : ''">创始人与团队</div>
      </router-link>
      <router-link to="/news" class="tab">
        <div :style="active == 1 ? 'color:#fff' : ''">新闻与报道</div>
      </router-link>
      <router-link to="/products" class="tab">
        <div :style="active == 1 ? 'color:#fff' : ''">产品中心</div>
      </router-link>
      <router-link to="/support" class="tab">
        <div :style="active == 1 ? 'color:#fff' : ''">支持</div>
      </router-link>
      <a
        :href="tmallFullUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="buyBtn"
        >前往天猫官方旗舰店</a
      >
    </div>
  </div>
</template>
<script>
import { purchase } from "@/data/facts";
export default {
  props: ["active"],
  data() {
    return {
      tmallFullUrl: purchase.tmallFullUrl,
    };
  },
};
</script>
<style scoped>
* {
  font-family: "fontnormal";
}

.app {
  position: absolute;
  z-index: 99;
  top: 0;
}

.main {
  display: flex;
  align-items: center;
  margin: 2.55vw 8.75vw;
}

.title {
  width: 8.5417vw;
  height: 1.25vw;
  margin-right: 6.25vw;
  background: url(../../assets/logo1.png) no-repeat;
  background-size: 100% 100%;
}

.blackTheme {
  background: url(../../assets/logo.png) no-repeat;
  background-size: 100% 100%;
}

.tab {
  font-size: 0.9vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  color: #333333;
  margin-right: 3vw;
  cursor: pointer;
  line-height: 1.25vw;
}

.tab.router-link-exact-active {
  color: #1b1e8a !important;
  border-bottom: 0.1vw solid #1b1e8a;
}

.buyBtn {
  margin-left: auto;
  background-color: #888ef9;
  color: #ffffff;
  font-size: 0.8vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  line-height: 1.25vw;
  padding: 0.5vw 1.5vw;
  border-radius: 0.3vw;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/HeaderBar.vue